//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postDecodeEncryptLogin,
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/backend_helper";

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend: any = getFirebaseBackend();
      response = fireBaseBackend.loginUser(user.email, user.password);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtLogin({
        email: user.email,
        password: user.password,
      });
    } else {
      if (!user.email && user.encryptedText) {
        const { ownCreateContractPrm, ...cleanedUser } = user;
        response = await postDecodeEncryptLogin({
          encryptedText: cleanedUser.encryptedText,
        });
      } else {
        response = await postFakeLogin({
          email: user.email,
          password: user.password,
        });
      }
    }
    var data = await response;

    if (typeof data === "object") {
      const errorMessage = data.message || "An error occurred during login";
      dispatch(apiError(errorMessage));
      return;
    }

    if (data) {
      sessionStorage.setItem("authUser", JSON.stringify(data));

      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        // var finalLogin: any = JSON.stringify(data);
        // finalLogin = JSON.parse(finalLogin);
        let finalLogin: any = JSON.parse(JSON.stringify(data));
        data = finalLogin.data;

        if (finalLogin) {
          await dispatch(loginSuccess(data));

          if (user.ownCreateContractPrm === "1") {
            history("/create-contract");
          } else {
            history("/dashboard");
          }

          window.location.reload();
        } else {
          dispatch(apiError(finalLogin));
        }
      } else {
        dispatch(loginSuccess(data));
        history("/dashboard");
      }
    }
  } catch (error: any) {
    dispatch(apiError(error.message || "Login failed"));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    sessionStorage.removeItem("authUser");
    let fireBaseBackend: any = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
